export default __webpack_public_path__ + "static/media/toNinteenGrade.53d5c3b5.png";